import * as React from "react"
import { Link, CMSState } from '../../../../cms/blocks/types.gen'
import { IOWidget, Updater, fromJSX } from 'widgets-for-react'
import { link } from "../../../../cms/blocks/utils.gen"
import { parseImageUrl } from "../../../../drupal/rendering/image_utils.mod"
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types.ext.gen"

export type contactBlockProps = {
    block_index: number,
    description: string,
    title: string,
    email: Array<string>,
    telephone: Array<string>,
    image?: ParsedMediaImage,
    link: Link,
    name: string,
    occupation: string
}

export type contactBlockStyle = {
}


export function contactBlock(
    props: contactBlockProps,
    options?: { style?: contactBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
    return cmsState => {
        return fromJSX(() => (
                    <section className={`block block--press${props.image != undefined ? ' has-image' : ''} grid--spacing`}>
                        <div className="block__inner container container--m grid--gutter">
                            <header className="block__header">
                                <h2 className="block__title title--l">{props.title}</h2>
                            </header>
                            <div className='block__content'>
                                <p className='block__name'>{props.name}</p>
                                <div className='block__column'>
                                    <ul className='block__list'>
                                        <li className='block__item block__item--bottom'>{props.occupation}</li>
                                        {props.telephone.map(number => {
                                            return <li className='block__item block__item--icon'>
                                                <svg className="block__icon" height="22" width="22">
                                                    <use xlinkHref="#icon--phone" />
                                                </svg>
                                                <a href={`tel:${number}`}>{number}</a>
                                            </li>
                                        }
                                        )}
                                        {props.email.map(mailAddress => {
                                            return <li className='block__item block__item--icon'>
                                                <svg className="block__icon" height="18" width="22">
                                                    <use xlinkHref="#icon--mail" />
                                                </svg>
                                                <a href={`mailto:${mailAddress}`}>{mailAddress}</a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                                <div className='block__column'>
                                    <p className='block__text'>{props.description} {props.link && props.link.url && link(props.link, { classname: "" }, props.link.title)}</p>
                                </div>
                            </div>
                            {props.image != undefined ?
                                <div className="block__visual fit-object">
                                    <img
                                        loading="lazy"
                                        src={parseImageUrl(props.image.field_media_image.image.url)}
                                        width="640"
                                        height="640"
                                        className="gallery__image"
                                        alt={props.image.field_media_image.alt} />
                                </div>
                                : <></>}
                        </div>
                    </section>
                )
        )
    }
}